import { apiClient } from '@/core/api/httpClient'

export default (uri) => ({
    create (payload) {
      return apiClient.post(`${uri}`, payload)
    },
    update (id, payload) {
      return apiClient.patch(`${uri}/${id}`, payload)
    },
    delete (id) {
      return apiClient.delete(`${uri}/${id}`)
    },
    getById: function (id) {
      return apiClient.get(`/${uri}/${id}`)
    },
})
